import { render, staticRenderFns } from "./ProcessCharacteristicShortDetailsCard.vue?vue&type=template&id=007e82a9&scoped=true"
import script from "./ProcessCharacteristicShortDetailsCard.vue?vue&type=script&lang=js"
export * from "./ProcessCharacteristicShortDetailsCard.vue?vue&type=script&lang=js"
import style0 from "./ProcessCharacteristicShortDetailsCard.vue?vue&type=style&index=0&id=007e82a9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "007e82a9",
  null
  
)

export default component.exports